import React from "react";
import { Eye, Video } from "lucide-react";

const CastingRecentApplicationsTable = ({
  activeTab,
  setActiveTab,
  filteredApplications,
  navigate
}) => {
  const getStatusBadge = (status = '') => {
    const s = String(status || '').toLowerCase();
    if (s === "pending" || s === "applied") return <span className="cdd-badge badge-yellow">PENDING</span>;
    if (s === "resubmit") return <span className="cdd-badge cdd-badge-resubmit">RESUBMIT</span>;
    if (s === "reviewed") return <span className="cdd-badge badge-blue">REVIEWED</span>;
    if (s === "shortlisted" || s === "selected") return <span className="cdd-badge badge-green">SHORTLISTED</span>;
    if (s === "rejected") return <span className="cdd-badge badge-red">REJECTED</span>;
    return <span className="cdd-badge badge-gray">{String(status || 'PENDING').toUpperCase()}</span>;
  };

  const getTypeBadge = (type = '') => {
    const t = String(type || '').toUpperCase();
    if (t.includes("ONLINE")) return <span className="cdd-type-badge type-online"><Video size={12}/> ONLINE</span>;
    if (t.includes("SLOT_BOOKING") || t.includes("WALK")) return <span className="cdd-type-badge type-walkin">WALK IN</span>;
    return <span className="cdd-type-badge type-gray">{t || 'ONLINE'}</span>;
  };

  return (
    <div className="cdd-card cdd-table-card">
      <div className="cdd-card-header d-flex justify-content-between align-items-center">
        <h2>Recent Applications</h2>
        
        {/* Desktop Filter Buttons */}
        <div className="cdd-table-filters d-none d-md-flex">
          <button className={activeTab === "all" ? "active" : ""} onClick={() => setActiveTab("all")}>All</button>
          <button className={activeTab === "pending" ? "active" : ""} onClick={() => setActiveTab("pending")}>Pending</button>
          <button className={activeTab === "shortlisted" ? "active" : ""} onClick={() => setActiveTab("shortlisted")}>Shortlisted</button>
        </div>

        {/* Mobile Select Dropdown (Right End) */}
        <select 
          className="cdd-select d-md-none" 
          value={activeTab} 
          onChange={(e) => setActiveTab(e.target.value)}
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="shortlisted">Shortlisted</option>
        </select>
      </div>

      <div className="cdd-table-responsive">
        <table className="cdd-table">
          <thead>
            <tr>
              <th>DATE</th>
              <th>CANDIDATE NAME</th>
              <th>ROLE TITLE</th>
              <th>PROJECT</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {filteredApplications.map((row) => (
              <tr key={row.id || row.roleApplicationId}>
                <td className="cdd-text-muted">{row.date}</td>
                <td>
                  <div className="cdd-candidate-cell">
                    <div className="cdd-avatar">{row.candidate ? String(row.candidate).charAt(0) : 'U'}</div>
                    <span className="cdd-candidate-name">{row.candidate}</span>
                  </div>
                </td>
                <td className="cdd-font-medium">{row.role}</td>
                <td className="cdd-text-muted">{row.project}</td>
                <td>{getTypeBadge(row.type)}</td>
                <td>{getStatusBadge(row.status)}</td>
                <td>
                  <button
                    className="cdd-eye-btn"
                    title="View Application"
                    onClick={() =>
                      navigate(`/dashboard/manage-applications/${row.id || row.roleApplicationId}`)
                    }
                  >
                    <Eye size={18} color="#ffffff" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CastingRecentApplicationsTable;
